import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { LoadingSpinnerService } from '../../services/loading-spinner-service';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './loading-spinner.html',
  styleUrl: './loading-spinner.scss',
})
export class LoadingSpinner {
  public loadingSpinnerService = inject(LoadingSpinnerService);
}
